module.exports = __webpack_public_path__ + "static/media/thumb.6f7e1ea3.jpeg";